import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { FormControl, Icon, FormSelectOutsideTag } from 'components/ui';
import { useGetCarePlansForList } from 'pages/CarePlans/_service/hooks/useGetCarePlansForList';
import { useDebounce } from 'use-debounce';

export default function PatientCarePlans({ form, disabled = false }) {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');
  const [searchCarePlansWithDelay] = useDebounce(searchValue, 300);

  const { carePlans, loading, loadMore } = useGetCarePlansForList({
    perPage: 20,
    filter: { title: searchCarePlansWithDelay, status: 'active' },
  });

  const handleScroll = (e) => {
    const target = e.target;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      loadMore();
    }
  };

  return (
    <Accordion
      title={t('Care plans')}
      startAdornment={<Icon icon="file-medical" />}
    >
      <FormControl label={t('Care plans')}>
        <FormSelectOutsideTag
          name="carePlans"
          disabled={disabled}
          getOptionLabel={(option) => option?.title || ''}
          getOptionValue={(option) => option?.id || ''}
          boxStyle={{ width: '100%' }}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          options={carePlans || []}
          onScroll={handleScroll}
          loading={loading}
          inputOnChange={setSearchValue}
          placeholder={t('Search and select care plans')}
          getTag={(item) => ({ title: item?.title, value: item?.id })}
          multiple
        />
      </FormControl>
    </Accordion>
  );
}
